import { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import WeatherDetails from './WeatherDetails';


const SearchBar = ({ setShowWeatherDetails, setSearchCityData }) => {

    const [searchSuggestions, setSearchSuggestions] = useState(null);
    const [searchCities, setSearchCities]= useState(null);
    const [inputValue, setInputValue] = useState('');

    const handleSearchSuggestions = (searchValue) => {

        setInputValue(searchValue)
        if (searchValue === '') {
            setSearchSuggestions(null);

        } else {

            fetch(`https://wft-geo-db.p.rapidapi.com/v1/geo/cities?minPopulation=1000000&namePrefix=${searchValue}`, {
                method: 'GET',
                headers: {
                    'X-RapidAPI-Key': 'a6df37813emsh4c2a3882b0fd3c0p13bb37jsn5bc1f62add74',
                    'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    const cities = data.data.map((item) => {
                        return { id: item.id, name: item.name, lat: item.latitude, long: item.longitude }
                    });
                    console.log(searchValue);
                    setSearchCities(cities);
                    setSearchSuggestions(cities);
                })
                .catch((error) => {
                    console.log(error.message);
                });
        }
    }

    const handleSubmit= (e)=>{
        e.preventDefault();
        if(inputValue!= null){
            
            setSearchCityData(searchCities.filter((item)=> item.name === inputValue)[0]);
            setShowWeatherDetails(true);
        }
        
    }


    return (
        <div className="searchbar">
            <p>Enter your city name to see weather details</p>
            <form onSubmit={ handleSubmit }>
                <input type="text"
                    placeholder="Search..."
                    value={inputValue}
                    onChange={(e) => handleSearchSuggestions(e.target.value)}
                />
                <button><FaSearch /></button>
            </form>
            {
                searchSuggestions &&
                <ul className='search-suggestions'>
                    {searchSuggestions.map((item) => {
                        return <li key={item.id}
                            onClick={() => {
                                setInputValue(item.name);
                                setSearchSuggestions(null);
                            }}>{item.name}</li>
                    })
                    }
                </ul>
            } 

        </div>
    );
};
export default SearchBar;